import React from 'react';
import { Shield, Award, FileText, Users } from 'lucide-react';

const trustItems = [
  { icon: Shield, label: 'JBCC, FIDIC, NEC3 & NEC4 Compliant' },
  { icon: FileText, label: 'AI-Powered Document Generation' },
  { icon: Award, label: 'Built by Construction Planners' },
  { icon: Users, label: 'Multi-Project, Multi-User Platform' },
];

export const TrustBar = () => (
  <section className="bg-slate-800 border-y border-slate-700">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
      <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3">
        {trustItems.map((item, idx) => {
          const IconComp = item.icon;
          return (
            <div key={idx} className="flex items-center gap-2.5 text-slate-400">
              <IconComp className="h-4 w-4 text-cyan-500 flex-shrink-0" />
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
